import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { I18nextProvider, initReactI18next } from "react-i18next";
import i18next from "i18next";

import common_de from "./config/translations/de/common.json";
import common_en from "./config/translations/en/common.json";
import common_hi from "./config/translations/hi/common.json";

import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./config/store/app.store";
import ErrorBoundary from "./components/ErrorBoundary.react";

i18next.use(initReactI18next).init({
    interpolation: { escapeValue: false }, // React already does escaping
    lng: "en", // language to use
    fallbackLng: "en",
    resources: {
        en: {
            common: common_en, // 'common' is our custom namespace
        },
        de: {
            common: common_de,
        },
        hi: {
            common: common_hi,
        },
    },
});

ReactDOM.render(
    // <React.StrictMode>
    <ErrorBoundary>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <I18nextProvider i18n={i18next}>
                    <App />
                </I18nextProvider>
            </PersistGate>
        </Provider>
    </ErrorBoundary>,
    // </React.StrictMode>,
    document.getElementById("root") || document.createElement("div")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
